import React, { FC } from 'react'

const FootnotePanel: FC<{
  data: Array<string>
  containerClassName?: string
  textClassName?: string
}> = ({
  data,
  containerClassName = 'px-6 py-15 laptop:px-0 laptop:py-16',
  textClassName = 'text-12 font-normal text-white/55 laptop:text-16',
}) => {
  return (
    <div className={['w-full bg-black', containerClassName].join(' ')}>
      <div className={['mx-auto', 'laptop:max-w-300'].join(' ')}>
        {!!data?.length &&
          data.map((item) => (
            <div className={textClassName} key={item}>
              {item}
            </div>
          ))}
      </div>
    </div>
  )
}
export default FootnotePanel
